const STORAGE_KEY = 'stocktakeListFilters';

export const STATUS_FILTER_VALUES = ['all', 'in_progress', 'done'];

const isValidDateInput = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

export const loadStocktakeListFilters = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!isValidDateInput(data?.dateFrom)) return null;
    const statusFilter = STATUS_FILTER_VALUES.includes(data?.statusFilter)
      ? data.statusFilter
      : 'all';
    return { dateFrom: data.dateFrom, statusFilter };
  } catch {
    return null;
  }
};

export const saveStocktakeListFilters = ({ dateFrom, statusFilter }) => {
  if (!isValidDateInput(dateFrom)) return;
  const filter = STATUS_FILTER_VALUES.includes(statusFilter) ? statusFilter : 'all';
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ dateFrom, statusFilter: filter }));
  } catch {
    /* ignore */
  }
};

export const clearStocktakeListFilters = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
